import React, { useId } from "react";
import "./CustomInput.css";
import ValidationHelper from '../ValidationHelper/ValidationHelper';


const generateSafeId = (id, name, alt, label, placeholder, reactId) => {
  if (id) return id;

  const source = name || alt || label || placeholder || reactId;

  const sanitized = source
    ?.toString()
    .trim()
    .toLowerCase()
    .replace(/:/g, "")          // remove React colon ids
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-_]/g, "");

  return sanitized || `field-${reactId.replace(/:/g, "")}`;
};


const CustomInput = ({
  id,
  type = 'text', 
  placeholder = '', 
  className = '', 
  error = false, 
  custom = false, 
  msg = "", 
  isSelect = false, // Add a prop to check if it's a select
  options = [], // Add a prop to pass options when it's a select
  name,
  alt,
  label,
  ...props 
}) => {
  const reactId = useId();
  const generatedId = generateSafeId(id, name, alt, label, placeholder, reactId);

  return (
    <>
      {isSelect ? (
        <select id={generatedId} data-testid={generatedId} className={`custom-input ${className}`} name={name} {...props}>
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          id={generatedId}
          data-testid={generatedId}
          type={type}
          placeholder={placeholder}
          className={`custom-input ${className}`}
          name={name}
          {...props}
        />
        
      )}
      <ValidationHelper placeholder={placeholder} error={error} custom={custom} msg={msg} />
    </>
  );
};

export default CustomInput;
